import type { FC } from "react";

import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

import type { IProModalCustomStyles } from "pro-features/components/Modals/src/ProModal";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";

import I18n from "pro-features/components/WithTranslation/src/I18n";

const Title = styled.div`
    height: 16px;
    padding: 24px;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;
const Content = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    width: 352px;
    padding: 24px;
`;
const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px;
`;

const proModalStyles: IProModalCustomStyles = {
    content: {
        boxSizing: "border-box",
        width: "400px",
        padding: 0,
    },
};

interface IDeleteIndustryConfirm {
    isOpen: boolean;
    numberOfKeywordsToRemove: number;
    onClose: VoidFunction;
    onDelete: VoidFunction;
}

export const ModalTableSelectionRemoveKeywords: FC<IDeleteIndustryConfirm> = ({
    isOpen,
    numberOfKeywordsToRemove,
    onClose,
    onDelete: onDeleteCallback,
}) => {
    const onDelete = () => {
        onClose();
        onDeleteCallback();
    };

    return (
        <ProModal
            isOpen={isOpen}
            customStyles={proModalStyles}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
        >
            <div className="TableSelectionRemoveKeywords">
                <Title>{translate("keyword.group.confirm.delete.title")}</Title>
                <Content>
                    <I18n dataObj={{ numberOfKeywordsToRemove }}>
                        {numberOfKeywordsToRemove > 1
                            ? "keyword.group.confirm.delete.content.plural"
                            : "keyword.group.confirm.delete.content.single"}
                    </I18n>
                </Content>
                <Footer>
                    <Button
                        type="flatDark"
                        onClick={onClose}
                    >
                        {translate("asset.sharing.footer.cancel")}
                    </Button>
                    <Button
                        type="warning"
                        onClick={onDelete}
                    >
                        {translate("common.delete")}
                    </Button>
                </Footer>
            </div>
        </ProModal>
    );
};
